module.exports = __webpack_public_path__ + "img/changeFineness-2.4fce2c1.webp";